import { decomposeColor, hslToRgb } from '@mui/material/styles';

export function getHexColorWithOpacity(color: string, opacity: number) {
  // first, parse the hex color into its composite RGB values, e.g. [255, 255, 255]
  const { values } = decomposeColor(color);
  // then, recompose it into rgba at the specified opacity
  return `rgba(${values.join(',')}, ${opacity})`;
}

/**
 * Convert any CSS color format (rgb, rgba, hsl, hsla, hex) to hex format
 * Uses MUI's color utilities to handle all standard CSS color formats
 * Mermaid accepts hex or unquoted rgb/hsl without spaces
 */
export function toHex(color: string): string {
  if (color.startsWith('#')) return color;

  try {
    const decomposed = decomposeColor(color);

    // HSL needs to be converted to RGB first
    let rgb: readonly number[];
    if (decomposed.type === 'hsl' || decomposed.type === 'hsla') {
      const rgbColor = hslToRgb(color);
      const rgbDecomposed = decomposeColor(rgbColor);
      rgb = rgbDecomposed.values;
    } else {
      rgb = decomposed.values;
    }

    const toHexPart = (value: number) => {
      const hex = Math.round(value).toString(16);
      return hex.length === 1 ? `0${hex}` : hex;
    };

    const [r = 0, g = 0, b = 0] = rgb;
    return `#${toHexPart(r)}${toHexPart(g)}${toHexPart(b)}`;
  } catch {
    return color;
  }
}
